// One accent per shared service — mirrors the Shared Services grid + map pins.
export const SERVICE_TONES = {
  ride: { main: "#4F988E", dark: "#3d7a72" }, taxi: { main: "#CA8A04", dark: "#A16207" },
  motor: { main: "#D9825A", dark: "#B96A45" }, tricycle: { main: "#D97706", dark: "#B45309" },
  van: { main: "#0E7490", dark: "#155E75" }, delivery: { main: "#5B8A72", dark: "#4A7360" },
  runner: { main: "#7C3AED", dark: "#6D28D9" }, laundry: { main: "#5A95CF", dark: "#437DB8" },
  trash: { main: "#5C3A21", dark: "#3E2415" },
};

export const SERVICE_LABELS = {
  ride: "Ride", taxi: "Taxi", motor: "Motor", tricycle: "Tricycle", van: "Van",
  delivery: "Delivery", runner: "Runner", laundry: "Laundry", trash: "Trash pickup",
};

export const serviceToneKey = (t) => {
  if (!t) return "ride";
  if (t.service_flavor === "trash" || t.service_flavor === "laundry") return t.service_flavor;
  const type = (t.rideshare_type || "").toLowerCase();
  const body = (t.body_style || t.driver_vehicle?.body_style || "").toLowerCase();
  if (type === "runner" || type === "delivery") return type;
  if (type === "van" || body === "van" || t.van_scheduled_start) return "van";
  if (body === "tricycle") return "tricycle";
  if (body === "taxi") return "taxi";
  return type === "motor" ? "motor" : "ride";
};
